import { useContext } from "react"
import { AppContext } from "./context"

const UiInput3 = ({w, value, setSearch, }) => {

	const {ww, qouteDelimiter} = useContext(AppContext)


	return (
		<div className="input3 d-flex justify-content-start gap-1" style={{height: 40}}>
			<div style={{width: 15, height: 15, marginTop: 7}} >
				<img  src={"/src/search.png"} style={{width: "100%", height: "100%"}}/>
			</div>
			<div  className="align-self-center w-100">
				<input className="w-100" type="text" value={value} onChange={e => setSearch(e.target.value)}/>
			</div>
			
		</div>

	)
}

export default UiInput3